import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = (app) => ({
  key: 'workorder.CreateSubmit',
  path: '/orders/create-work-order',
  title: 'Create Work Order - Client ID <<###>> - Billing ID <<##>>',
  component: dynamicWrapper(app, [import('./model')], () => import('./components')),
  props: true
});

export default (app) => createRoute(app, routesConfig);